import ChallengeLine from './ChallengeLine.vue';

// @ts-ignore
ChallengeLine.install = (Vue) => {
  Vue.component((ChallengeLine as any).options.name, ChallengeLine);
};

export default ChallengeLine;
